export const PRODUCT_FILTER = {
  ALL: 'all',
  PAGES: 'pages',
  COLLECTIONS: 'collections',
}
